<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" :key="isSmallerScreen">
    <vs-tab icon-pack="feather" icon="icon-mail" :label="!isSmallerScreen ? '이메일로 검색' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <searchMail />
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-clipboard" :label="!isSmallerScreen ? '레벨로 검색' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <searchLevel />
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? '아이디로 검색' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
      </div>
      <searchId />
    </vs-tab>

  </vs-tabs>
</template>


<script>
import searchMail from "./searchMail.vue"
import searchLevel from "./searchLevel.vue"
import searchId from "./searchId.vue"

export default {
  components: {
    searchMail,
    searchLevel,
    searchId,
    },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>
